export default [
  {
    path: 'transactions',
    name: 'accountant-transactions',
    component: () => import('@/view/pages/transaction/Transaction.vue'),
    children: [
      {
        path: ':mode',
        name: 'list-transaction',
        component: () => import('@/view/pages/transaction/ListTransaction.vue'),
        props: true,
        meta: {
          title: 'Phiếu thu chi - ClickBuy',
        },
      },
      {
        path: ':mode/:action/:id',
        name: 'transaction',
        component: () => import('@/view/pages/transaction/AddTransaction.vue'),
        props: true,
      },
    ],
  },
  {
    path: 'print-transaction',
    name: 'print-transaction',
    component: () => import('@/view/pages/transaction/PrintTransaction.vue'),
    props: true,
    meta: {
      title: 'In phiếu thu chi - ClickBuy',
    },
  },
];
